// extracted by mini-css-extract-plugin
module.exports = {"dropWrapper":"DropCard_dropWrapper__2H1wv","dropImageCard":"DropCard_dropImageCard__DzXYd"};